<script setup>
import { useUiStore } from '../../stores/ui';

const uiStore = useUiStore();
</script>

<template>

    <Transition
        enter-active-class="tw-transition tw-transform tw-duration-500 tw-ease-in-out"
        leave-active-class="tw-transition tw-transform tw-duration-500 tw-ease-in-out"
        enter-from-class="tw-translate-y-full lg:tw-translate-y-0 lg:tw-translate-x-full"
        enter-to-class="tw-translate-y-0 tw-translate-x-0"
        leave-from-class="tw-translate-y-0 tw-translate-x-0"
        leave-to-class="tw-translate-y-full lg:tw-translate-y-0 lg:tw-translate-x-full"
    >
        <div
            class="tw-bg-white height-screen-minus-35-vw lg:tw-h-auto tw-w-full tw-max-w-md tw-text-gray-700 tw-absolute lg:tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 lg:tw-left-auto tw-py-6 md:tw-py-10 lg:tw-py-16 tw-px-4 md:tw-px-6 lg:tw-px-10 tw-z-40"
            v-show="uiStore.details && uiStore.showDetails"
        >
            <h2 class="tw-text-32 tw-font-medium tw-mb-4 md:tw-mb-6 lg:tw-mb-8" v-text="uiStore.details?.title"></h2>
            <div class="tw-text-20" v-text="uiStore.details?.description"></div>
        </div>
    </Transition>
</template>